export default "__VITE_ASSET__DWPPX86R__"